export const escapeSpecialChars = (str: string): string => {
    const regex = /(\$|\(|\)|\*|\[|\]|,)/g;
    const escapedStr = str.replace(regex, char => `$${char}`);

    return escapedStr;
};
